<template>
  <div>
    <p class="mt-10" style="color: #6B7280;">
      {{ t('donorDetails.form.personalInfo.hint') }}
    </p>
    <div class="pa-0 mt-10" style="color: #6B7280 !important;font-size: 19px;font-weight: 500;">
      {{ t('donorDetails.form.personalInfo.label') }}
    </div>
    <option-label class="mb-0 mt-5" :title="t('donorDetails.form.email.label')" />
    <v-text-field
      ref="email"
      v-model="donor.email"
      data-cy="basic-donor-form-email-field"
      :persistent-hint="false"
      :validate-on-blur="true"
      :placeholder="t('donorDetails.form.email.placeholder')"
      :hint="t('donorDetails.form.email.hint')"
      :rules="emailRules"
      append-inner-icon="mdi-email-outline"
      type="email"
      density="comfortable"
      @keydown.space.prevent
    />
    <v-row class="pt-0 pb-0">
      <v-col cols="12" md="6" class="pb-0">
        <option-label class="mb-0" :title="t('donorDetails.form.firstname.label')" />
        <v-text-field
          v-model="donor.firstname"
          data-cy="basic-donor-form-firstname-field"
          :placeholder="t('donorDetails.form.firstname.placeholder')"
          :hint="t('donorDetails.form.firstname.hint')"
          density="comfortable"
        />
      </v-col>
      <v-col cols="12" md="6" class="pb-0">
        <option-label class="mb-0" :title="t('donorDetails.form.lastname.label')" />
        <v-text-field
          v-model="donor.surname"
          data-cy="basic-donor-form-surname-field"
          :placeholder="t('donorDetails.form.lastname.placeholder')"
          :hint="t('donorDetails.form.lastname.hint')"
          density="comfortable"
        />
      </v-col>
    </v-row>
    <div class="pt-10" style="font-size: 16px;">
      <div class="pa-0 mt-0" style="color: #6B7280 !important;font-size: 19px;font-weight: 500;">
      {{ t('donorDetails.form.address.label') }}
    </div>
    </div>
    <v-row class="mt-0">
      <v-col cols="12" md="6" class="pb-0">
        <option-label class="mb-0" :title="t('donorDetails.form.address.label')" /> <!-- Address1 field -->
        <v-text-field
          v-model="donor.address.address1"
          data-cy="basic-donor-form-address1-field"
          :placeholder="t('donorDetails.form.address.placeholder')"
          :hint="t('donorDetails.form.address.hint')"
          density="comfortable"
        />
      </v-col>
      <v-col cols="12" md="6" class="pb-0">
        <option-label class="mb-0" :title="t('donorDetails.form.postcode.label')" />
        <v-text-field
          v-model="donor.address.postcode"
          data-cy="basic-donor-form-postcode-field"
          :placeholder="t('donorDetails.form.postcode.placeholder')"
          :hint="t('donorDetails.form.postcode.hint')"
          density="comfortable"
        />
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="6">
        <option-label class="mb-0" :title="t('donorDetails.form.city.label')" />
        <v-text-field
          v-model="donor.address.city"
          data-cy="basic-donor-form-city-field"
          :placeholder="t('donorDetails.form.city.placeholder')"
          :hint="t('donorDetails.form.city.hint')"
          density="comfortable"
        />
      </v-col>
      <v-col cols="12" md="6">
        <option-label class="mb-0" :title="t('donorDetails.form.country.label')" />
        <v-text-field
          v-model="donor.address.country"
          data-cy="basic-donor-form-country-field"
          :placeholder="t('donorDetails.form.country.placeholder')"
          :hint="t('donorDetails.form.country.hint')"
          density="comfortable"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useLabel } from '@/composables/useLabel';
import { Donor } from '@/interfaces/donation/donor';
import OptionLabel from '@/components/OptionLabel.vue';
import { useValidationRules } from '@/composables/useValidationRules';
import store from '@/store';
export default defineComponent({
  components: {
    OptionLabel,
  },
  props: {
    modelValue: {
      type: Object as () => Donor,
      default: () => ({}) as Donor,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { t } = useLabel();
    const { rules: baseRules } = useValidationRules(t);

    const donor = computed({
      get(): Donor {
        return props.modelValue || ({} as Donor);
      },
      set(val: Donor) {
        emit('update:modelValue', val);
      },
    });
    // Email is optional for contribution flow with organization group
    const hasOrganizationGroup = computed(() => {
      return Boolean(store.state.requestSession?.organizationGroup);
    });

    const emailRules = computed(() => {
      if (hasOrganizationGroup.value) {
        // If email is provided it must be a valid email address
        return [baseRules.value.email];
      }
      // Email required for other flows
      return [baseRules.value.email, baseRules.value.required];
    });

    return {
      t,
      donor,
      rules: baseRules,
      emailRules,
    };
  },
});
</script>
